module.exports = __webpack_public_path__ + "img/virgule-red.b11c4e18.svg";